import React from "react";
import { useLocation } from "react-router-dom";
import { Camera } from "lucide-react";
import { useEditMode } from "../EditModeContext";

// Floating "change photo" badge shown only in admin edit mode.
// Must be placed inside a `relative` container.
export default function EditableImage({ imageKey, label = "Change photo", pos = "top-3 right-3" }) {
  const { editMode, setTarget, isAdmin } = useEditMode();
  const { pathname } = useLocation();
  if (!editMode || !isAdmin || pathname.startsWith("/admin")) return null;
  return (
    <button
      type="button"
      data-testid={`editable-image-${imageKey}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setTarget({ type: "image", imgKey: imageKey, label });
      }}
      className={`absolute z-30 ${pos} inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-foreground/90 text-background text-[0.6rem] tracking-[0.2em] uppercase shadow-lg hover:bg-primary hover:text-primary-foreground transition-colors`}
    >
      <Camera size={11} strokeWidth={1.4} /> {label}
    </button>
  );
}
